package uz.ferro.erp.pages.home

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.useContext
import react.useEffectOnce
import uz.ferro.erp.NavigationContext


val Home = FC<Props> {
    val navigator = useContext(NavigationContext)
    useEffectOnce {
        MainScope().launch {
            navigator.openMain()
        }
    }
}